export default function CTA() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/84d7989d687dc489480783e921c3ecb6.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            ¿Listo para Vivir en España?
          </h2>
          <p className="text-xl text-blue-100">
            Agenda tu consulta y da el primer paso hacia tu nueva vida en España
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-1 gap-8">
            <div className="bg-white rounded-2xl shadow-2xl p-8 text-gray-900">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-6">
                <i className="ri-calendar-check-fill text-4xl text-blue-600"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Consulta Profesional</h3>
              <p className="text-lg text-gray-600 mb-6">
                Evaluación completa de tu caso + estrategia personalizada
              </p>
              <a 
                href="#consulta"
                className="block w-full bg-blue-600 text-white py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-all whitespace-nowrap cursor-pointer text-center"
              >
                Ver Opciones de Consulta
              </a>
              <p className="text-sm text-gray-500 mt-4">
                ✓ Evaluación completa | ✓ Estrategia personalizada
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
